const STYLES = {
  Active: "bg-[#ECFDF5] text-[#047857]",
  "Setup Required": "bg-[#F3E8FF] text-[#6B21A8]",
  "Coming Soon": "bg-[#F3F4F6] text-[#4B5563]",
};

export default function StatusBadge({ status }) {
  const cls = STYLES[status] || STYLES["Coming Soon"];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ${cls}`}
      data-testid={`status-badge-${status.replace(/\s+/g, "-").toLowerCase()}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {status}
    </span>
  );
}
